import React, { Component } from 'react';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import '../Components/WorkbookStyle.css';
import { Container, Col, Row, Card, Accordion } from 'react-bootstrap'
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from 'pure-react-carousel'
import Modal from 'react-modal'
import api from 'lib/api';
import global from 'lib/global';
import { Link } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link';
import firebase from 'lib/firebase';
import HeaderWrite from '../Components/HeaderWrite';

import * as UserActions from 'store/modules/UserModule';

const step_data = [
    {
        count_like: '01',
        step: "Go to Boomco website, fill in your email address, and choose the difficulty level of the weekly worksheets.",
        alt: "how to step1",
        how: "/write/ad_way01.png"
    },
    {
        count_like: '02',
        step: "Weekly worksheets and an individual link will be sent to your email.",
        alt: "how to step2",
        how: "/write/ad_way02.png"
    },
    {
        count_like: '03',
        step: "After completing the worksheets, upload your worksheets on the individual link.",
        alt: "how to step3",
        how: "/write/ad_way03.png"
    },
    {
        count_like: '04',
        step: "An email will be sent to you when the feedback is ready! (Normally, it will take about 3 working days for the feedback.)",
        alt: "how to step4",
        how: "/write/ad_way04.png"
    },
    // {
    //     count_like: '05',
    //     step: "An email will be sent to you when the feedbacks are ready! (Normally, it will take about 3 days for the feedbacks.)",
    //     alt: "how to step5",
    //     how: "/write/ad_way05.png"
    // },
];


const review_data = [
    {
        id: 1,
        name: "Lucy S.",
        profile: "/write/ad_st01.png",
        review: "The strongest benefit is that you can study Korean according to your own schedule. You can study only during the weekends or even 10 minutes everyday in the morning. Studying is always possible when you are available."
    },
    {
        id: 2,
        name: "Amelia L.",
        profile: "/write/ad_st02.png",
        review: "I used to study Korean alone using textbooks. When I studied this way, I was not able to exactly find out if my answers were correct or not. However, after receiving the score and feedbacks from the teacher, now I know precisely what my weaknesses are. Moreover, the feedbacks helps me to review as well."
    },
    {
        id: 3,
        name: "Keily A.",
        profile: "/write/ad_st03.png",
        review: "Because I learn better by writing down, Boomco weekly worksheets fit me perfectly. For me, I complete the activities by writing on iPad, but it is also fascinating to print out the worksheets and write with colorful pens."
    },
]


class AdvertisementScreen extends Component {
    constructor(props) {
        super(props);

        // let visibleModal = false;
        // if (this.props.userInfo.idx) {
        //     visibleModal = false;
        // }

        this.state = {
            userInfo: '',

            visibleModal: false,
            visibleAlert: false,
            alert: '',

            paypalModal: false,
            paypalMonth: 0,
            paypalLevel: 0,
            paypalEmail: "",

            sendLevel: 0,
            sendName: "",
            sendEmail: "",
            sendText: "",
        }
    }

    componentDidMount() {
        const self = this;

        firebase.auth().onAuthStateChanged(async function (user) {
            let userData = await self.props.userActions.getUserInfo();
            if (userData.data.result) {
                self.setState({ userInfo: userData.data.data });
            }
        });
    }

    onClickApply = () => {
        this.setState({ visibleModal: !this.state.visibleModal });
    }

    onClickPaypal1 = () => {
        this.setState({ paypalModal: !this.state.paypalModal, paypalMonth: 1 });
        console.log("paypal 1 month")
    }

    onClickPaypal2 = () => {
        this.setState({ paypalModal: !this.state.paypalModal, paypalMonth: 3 });
        console.log("paypal 3 months")
    }

    onClickPaypal3 = (e) => {
        this.setState({ paypalModal: !this.state.paypalModal, paypalMonth: 6 });
        console.log("paypal 6 months")
    }

    onChangePaypalLevel = (e) => {
        this.setState({ paypalLevel: e.target.value });
    }

    onChangePaypalEmail = (e) => {
        this.setState({ paypalEmail: e.target.value });
    }

    onClickPaypalSubmit = () => {
        //https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=A6AZE3Y23XK98&level=1&email=hkzld@naver.com
        const self = this;

        if (this.state.paypalLevel == 0) {
            //추가 - 레벨을 선택해주세요
            this.setState({
                alert: "Choose the difficulty of the worksheets.",
                visibleAlert: !this.state.visibleAlert
            })
            return;
        }

        let email = "";
        if (this.props.userInfo.email && this.props.userInfo.email.length) {
            email = this.props.userInfo.email;
        } else {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!this.state.paypalEmail || !re.test(this.state.paypalEmail)) {
                //추가 - 이메일 형식이 잘못되었습니다
                this.setState({
                    alert: "Please fill in the blank with your email address, following the form given.",
                    visibleAlert: !this.state.visibleAlert
                })
                return;
            }
        }

        let paypalUrl;
        if (this.state.paypalMonth == 1) {
            paypalUrl = "https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=9GDSKRGRU2TK6";
        } else if (this.state.paypalMonth == 3) {
            paypalUrl = "https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=2T3ERLKUQ5W4U";
        } else if (this.state.paypalMonth == 6) {
            paypalUrl = "https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=5LPMRLPXNPT3C";
        }

        paypalUrl = paypalUrl + "&level=" + this.state.paypalLevel.toString() + "&email=" + email;

        window.open(paypalUrl, "_blank")
    }



    // 신청 모달
    changeLevel = (e) => {
        console.log("choosed level")
        this.setState({ sendLevel: e.target.value });
    }

    changeName = (e) => {
        console.log("input name")

        let name = e.target.value;
        var regExp = /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi; //특수문자 제거
        name = name.replace(regExp, "");

        this.setState({ sendName: name });
    }

    changeEmail = (e) => {
        console.log("input email")
        this.setState({ sendEmail: e.target.value });
    }

    changeText = (e) => {
        console.log("input text")
        this.setState({ sendText: e.target.value });
    }

    onClickSubmit = () => {
        const self = this;

        if (this.state.sendLevel == 0) {
            //추가 - 레벨을 선택해주세요
            this.setState({
                alert: "Choose the difficulty of the worksheets.",
                visibleAlert: !this.state.visibleAlert
            })
            return;
        }

        if (!this.state.sendName || this.state.sendName.length < 3) {
            //추가 - 닉네임을 입력해 주세요
            this.setState({
                alert: "Please write your nickname 'more than 3 words'.",
                visibleAlert: !this.state.visibleAlert
            })
            return;
        }

        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!this.state.sendEmail || !re.test(this.state.sendEmail)) {
            //추가 - 이메일 형식이 잘못되었습니다
            this.setState({
                alert: "Please fill in the blank with your email address, following the form given.",
                visibleAlert: !this.state.visibleAlert
            })
            return;
        }

        if (this.state.sendText.length > 500) {
            this.setState({
                alert: "Please write under 500 letters.",
                visibleAlert: !this.state.visibleAlert
            })
            return;
        }

        let item = {
            name: this.state.sendName,
            email: this.state.sendEmail,
            level: this.state.sendLevel,
            memo: this.state.sendText,
        }

        api.post('/workbook/users/joinAdd', { item: item })
            .then(function (response) {
                if (response.data.result) {
                    //추가 - 등록이 완료되었습니다
                    self.setState({
                        alert: "Your registration has been completed successfully.",
                        visibleModal: !self.state.visibleModal,
                        visibleAlert: !self.state.visibleAlert
                    })
                } else {
                    //추가 - 등록이 실패 하였습니다
                    self.setState({
                        alert: "Your email has already been registered.",
                        visibleAlert: !self.state.visibleAlert
                    })
                }
            })
            .catch(function (err) {
                //추가 - 등록이 실패 하였습니다
                self.setState({
                    alert: "The registration has failed.",
                    visibleAlert: !self.state.visibleAlert
                })
            })
    }


    render() {
        let step_table = step_data.map((data) =>
            <Card style={{ borderColor: '#ce3b33', borderWidth: 2 }}>
                <Accordion.Toggle
                    as={Card.Header}
                    eventKey={data.count_like}
                    style={{ backgroundColor: '#fff', textAlign: 'left' }} >
                    <Container>
                        <Row>
                            <Col xs={1} sm={1} md={1} lg={1} className="accordion_No my-auto">{data.count_like}</Col>
                            <Col xs={11} sm={11} md={11} lg={11} className="accordion_head my-auto">{data.step}</Col>
                            {/* <Col lg={0.5}>{data.count_like}</Col> */}
                        </Row>
                    </Container>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey={data.count_like} style={{ backgroundColor: '#e9e9e9', textAlign: 'left' }}>
                    <Card.Body className="accordion_how">
                        <img src={data.how} alt={data.alt} style={{ width: '100%' }} />
                    </Card.Body>
                </Accordion.Collapse>
            </Card>
        );

        let review_table = review_data.map((data) =>
            // <Slide index={data.id} className="reviewTable" >
            <Col xs={12} sm={12} md={4} lg={4}>
                <div className="reivewContainer">
                    <div className="hr"></div>
                    <p className="reviewText">{data.review}</p>
                    <p className="reviewName">{data.name}</p>
                    <img src={data.profile} alt="profile image" className="reviewProfile" />
                </div>
            </Col>
            // </Slide>

        );

        let LayoutApplyInputName = (
            <input type="text" placeholder="Name" onChange={this.changeName} value={this.state.sendName}></input>
        )
        let LayoutApplyInputEmail = (
            <input type="email" placeholder="Email address" onChange={this.changeEmail}></input>
        )
        let LayoutPayInputEmail = (
            <input type="email" placeholder="Email address" onChange={this.onChangePaypalEmail}></input>
        )
        if (this.props.userInfo.idx) {
            LayoutApplyInputName = (
                <input type="text" placeholder="Name" onChange={this.changeName} value={this.state.userInfo.nick_name} disabled></input>
            );

            LayoutApplyInputEmail = (
                <input type="email" placeholder="Email address" onChange={this.changeEmail} value={this.state.userInfo.email} disabled></input>
            );

            LayoutPayInputEmail = (
                <input type="email" placeholder="Email address" disabled={true} value={this.props.userInfo.email}></input>
            );
        }


        return (
            <div id="write_ad">
                {/* header */}
                <HeaderWrite />

                <div style={{ backgroundColor: '#ce3b33' }}>
                    <div id="home">
                        <div className="home_inner">
                            <Container stylele={{ overflow: 'hidden' }}>
                                <Row>
                                    <Col xs={12} sm={12} md={7} lg={7}>
                                        <p className="subTitle">The first step<br />to learn Korean :</p>
                                        <h1>Boomco<br />Weekly<br />Worksheets</h1>
                                        <p className="catchphrase">Exercise by solving problems weekly, get feedback from professionals 1:1!<br />Apply it right now for free!</p>
                                        <ul className="benefit">
                                            <li>The best individualized Korean education</li>
                                            <li>Even small spelling mistakes will be checked precisely</li>
                                            <li>Persistent learning is possible with weekly worksheets</li>
                                        </ul>
                                        <a className="apply_contents" onClick={this.onClickApply}>
                                            Apply now
                                    <img src={"/write/ad_icon_arrow.png"} alt="right_arrow" style={{ width: 20, marginLeft: 16 }} />
                                        </a>
                                    </Col>
                                    <Col xs={12} sm={12} md={5} lg={5} style={{ textAlign: 'center' }}>
                                        <img src={"/write/ad_tutor01_210819.png"} alt="free_event_period" className="tutor01" />
                                    </Col>
                                </Row>
                            </Container>
                            <Container className="explainContainer">
                                <Row style={{ backgroundColor: '#eee', alignItems: 'center' }}>
                                    <Col className="expainSpace my-auto" style={{ marginRight: 1 }}>
                                        <img src={"/write/ad_benefit01.png"} alt="image1" className="expainImg" />
                                        <p style={{ marginBottom: '10%' }}>Inexpensive cost</p>
                                        <img src={"/write/ad_benefit03.png"} alt="image2" className="expainImg" />
                                        <p style={{ marginBottom: 0 }}>Flexible learning time</p>
                                    </Col>
                                    <Col className="expainSpace my-auto">
                                        <img src={"/write/ad_benefit02.png"} alt="image3" className="expainImg" />
                                        <p style={{ marginBottom: '10%' }}>Individualized learning</p>
                                        <img src={"/write/ad_benefit04.png"} alt="image4" className="expainImg" />
                                        <p style={{ marginBottom: 0 }}>One-to-one care by a native professional Korean teacher</p>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                    </div>

                    <div id="howitworks">
                        <h2 className="title">A trendy and classic way<br />to learn Korean</h2>
                        <img src={"/write/ad_tutor02.png"} alt="woman" style={{ width: '25%' }} />
                        <div className="accordionContainer">
                            <Accordion>
                                {step_table}
                            </Accordion>
                        </div>
                    </div>

                    <div id="reviews">
                        <h2 className="title">A Korean present<br />I give myself every week,<br />Boomco Korean weekly worksheets</h2>
                        <Container>
                            <Row>
                                {review_table}
                            </Row>
                        </Container>

                        {/* review carousel 
                        <CarouselProvider
                            naturalSlideWidth={0}
                            naturalSlideHeight={0}
                            totalSlides={review_data.length}
                            visibleSlides={3}
                            orientation={"horizontal"}
                            touchEnabled={false}
                            dragEnabled={false}
                            infinite={false}
                            interval={3000}
                            isPlaying={false}
                            style={{ backgroundColor: 'transparent', width: '100%' }}
                        >
                            <Slider classNameAnimation={"slide"} style={{ width: '100%', backgroundColor: "orange" }}>
                                {review_table}
                            </Slider>
                            <div style={{ textAlign: 'center' }}>
                                <ButtonBack className="buttonCarousel">
                                    <img src={"/write/ad_carousel_arrow.png"} alt="pre button" style={{ width: '50%', marginTop: -3 }} />
                                </ButtonBack>
                                <ButtonNext className="buttonCarousel">
                                    <img src={"/write/ad_carousel_arrow.png"} alt="pre button" style={{ width: '50%', marginTop: -3, transform: 'rotate(180deg)' }} />
                                </ButtonNext>
                            </div>
                        </CarouselProvider> */}
                    </div>

                    <div id="whoweare">
                        <h3 style={{ color: '#d4b6a0' }}>Who we are?</h3>
                        <p>Boomco is seeking for a way to learn Korean easily, delightfully, and efficiently.<br />Boomco is developing programs with professional IT developers,<br />based on the verified curriculum developed by Korean education professionals.<br />The programs are seeking for the best way to improve speaking, writing, reading, and writing skills in a balanced way.</p>
                    </div>
                </div>
                <div id="subscribe">
                    <h3 style={{ color: '#333', marginBottom: '4%', }}>Boomco sale promotion<br /><thin style={{ fontWeight: 'normal', fontSize: 37 }}>Until August 31, 2021</thin></h3>
                    <Container>
                        <Row>
                            <Col xs={12} sm={12} md={4} lg={4} className="my-auto">
                                <div className="workbook">
                                    <img src={"/write/ad_book01.png"} alt="work book" className="workbookImg" />
                                    <div className="sale" style={{ backgroundColor: '#fff' }}>
                                        <p className="salePercentage" style={{ color: '#aaa' }}>30%</p>
                                        <p className="saleText" style={{ color: '#aaa' }}>Sale</p>
                                    </div>
                                </div>
                                <p className="salePeriod">1 month</p>
                                <ul>
                                    <li className="priceOriginal" style={{ width: '15%' }}>$200</li>
                                    <li className="priceDiscount" style={{ width: '50%' }}>$140</li>
                                    <li className="pricePaypal" style={{ width: '35%' }}><a onClick={this.onClickPaypal1}>Paypal</a></li>
                                </ul>
                            </Col>
                            <Col xs={12} sm={12} md={4} lg={4} className="my-auto">
                                <div className="workbook">
                                    <img src={"/write/ad_book02.png"} alt="work book" className="workbookImg" />
                                    <div className="sale" style={{ backgroundColor: '#ce3b33' }}>
                                        <p className="salePercentage">40%</p>
                                        <p className="saleText">Sale</p>
                                    </div>
                                </div>
                                <p className="salePeriod">3 months</p>
                                <ul>
                                    <li className="priceOriginal" style={{ width: '15%' }}>$600</li>
                                    <li className="priceDiscount" style={{ width: '50%' }}>$360</li>
                                    <li className="pricePaypal" style={{ width: '35%' }}><a onClick={this.onClickPaypal2}>Paypal</a></li>
                                </ul>
                            </Col>
                            <Col xs={12} sm={12} md={4} lg={4}>
                                <div className="workbook" x>
                                    <img src={"/write/ad_book03.png"} alt="work book" className="workbookImg" />
                                    <div className="sale" style={{ backgroundColor: '#000' }}>
                                        <p className="salePercentage">50%</p>
                                        <p className="saleText">Sale</p>
                                    </div>
                                </div>
                                <p className="salePeriod">6 months</p>
                                <ul>
                                    <li className="priceOriginal" style={{ width: '15%' }}>$1200</li>
                                    <li className="priceDiscount" style={{ width: '50%' }}>$600</li>
                                    <li className="pricePaypal" style={{ width: '35%' }}><a onClick={this.onClickPaypal3}>Paypal</a></li>
                                </ul>
                            </Col>
                        </Row>
                    </Container>
                </div>

                <div style={{ backgroundColor: '#ce3b33' }}>
                    <div id="familyservice">
                        <h3 style={{ color: '#56100c', marginBottom: '4%' }}>Family Service</h3>
                        <Container>
                            <Row>
                                <Col xs={12} sm={12} md={6} lg={3} className="my-auto" style={{ padding: 0 }}>
                                    <div className="serviceList">
                                        <img src={"/write/ad_service01.png"} alt="image1" className="serviceImg" />
                                        <p>A Korean education service with trendy K-culture video clips</p>
                                        <a className="clickhere" href="https://app.boomco.io/" target="blank">Click here</a>
                                    </div>
                                </Col>
                                <Col xs={12} sm={12} md={6} lg={3} className="my-auto" style={{ padding: 0 }}>
                                    <div className="serviceList list-md-right">
                                        <img src={"/write/ad_service02.png"} alt="image1" className="serviceImg" />
                                        <p>Subscription on Korean newsletter with up-to-date Korean issues</p>
                                        <a className="clickhere" href="https://boomco.io/" target="blank">Click here</a>
                                    </div>
                                </Col>
                                <Col xs={12} sm={12} md={6} lg={3} className="my-auto" style={{ padding: 0 }}>
                                    <div className="serviceList">
                                        <img src={"/write/ad_service03.png"} alt="image1" className="serviceImg" />
                                        <p>One-to-one online lecture service</p>
                                        <a style={{ color: '#f99d9d', cursor: 'default' }}>Preparing</a>
                                    </div>
                                </Col>
                                <Col xs={12} sm={12} md={6} lg={3} className="my-auto" style={{ padding: 0 }}>
                                    <div className="serviceList list-right">
                                        <img src={"/write/ad_service04.png"} alt="image1" className="serviceImg" />
                                        <p>Korean textbook with practical and systematic curriculum</p>
                                        <a style={{ color: '#f99d9d', cursor: 'default' }}>Book</a>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                        <Container className="sns">
                            <Row>
                                <Col xs={4} sm={4} md={4} lg={4}>
                                    <a href="https://www.instagram.com/boomco_wave/" target="blank">
                                        <img src={"/write/ad_instagram.png"} alt="instagram" className="snsImg" />
                                    </a>
                                </Col>
                                <Col xs={4} sm={4} md={4} lg={4}>
                                    <a href="https://www.facebook.com/boomco.wave" target="blank">
                                        <img src={"/write/ad_facebook.png"} alt="facebook" className="snsImg" />
                                    </a>
                                </Col>
                                <Col xs={4} sm={4} md={4} lg={4}>
                                    <a href="https://www.pinterest.co.kr/boomco_wave" target="blank">
                                        <img src={"/write/ad_pinterest.png"} alt="pinterest" className="snsImg" />
                                    </a>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </div>

                <footer>
                    <img src={"/write/ad_logo_icon.png"} alt="boomco logo" style={{ height: '100%', marginBottom: '1%' }} />
                    <p>Copyright 2021. boomco</p>
                    <p>1:1 Customer Center : <a href="mailto:boomco@boomco.org">boomco@boomco.org</a></p>
                </footer>

                {/* modal(신청입력) */}
                <Modal
                    isOpen={this.state.visibleModal}
                    onRequestClose={() => this.setState({ visibleModal: false })}
                    className="Modal"
                    overlayClassName="Overlay"
                >
                    <h3>Register now {'\u0026'}<br />Receive <strong>ONE FREE</strong> worksheets</h3>
                    <select onChange={this.changeLevel} >
                        <option value={0} disabled selected hidden>Choose the level of worksheets</option>
                        <option value={1}>Beginner</option>
                        <option value={2}>Intermediate - Advanced</option>
                    </select>
                    {LayoutApplyInputName}
                    {LayoutApplyInputEmail}
                    <textarea type="textarea" placeholder="Other (You may leave it empty)" className="textArea" onChange={this.changeText}></textarea>
                    <p className="warning">{'\u203B'}{'\u00A0'}If you can not find your email in your normal mailbox, please check in your spam or junk mail sections. And if you find our email there, select the confirmation message and click “not junk”.</p>
                    {/* <p style={{ color: '#666', fontSize: 15, letterSpacing: -0.5 }}><strong style={{ color: '#E51414', fontSize: 17 }}>{'\u203B'}{'\u00A0'}Holiday Notice</strong><br />We will be closed from 10th Feb 2021 - 15th Feb 2021. We are back on 16th Feb 2021.</p> */}
                    <div className="submit" onClick={this.onClickSubmit}>Apply now</div>
                </Modal>


                {/* modal(Paypal) */}
                <Modal
                    isOpen={this.state.paypalModal}
                    onRequestClose={() => this.setState({ paypalModal: false })}
                    className="Modal"
                    overlayClassName="Overlay"
                >
                    <h3>Register now {'\u0026'}<br />Receive feedback for <strong>{this.state.paypalMonth} Month</strong></h3>
                    <select onChange={this.onChangePaypalLevel} >
                        <option value={0} disabled selected hidden>Choose the level of worksheets</option>
                        <option value={1}>Beginner</option>
                        <option value={2}>Intermediate - Advanced</option>
                    </select>
                    {LayoutPayInputEmail}
                    <div className="submit" onClick={this.onClickPaypalSubmit}>Paypal</div>
                </Modal>


                {/* modal(경고문) */}
                <Modal
                    isOpen={this.state.visibleAlert}
                    onRequestClose={() => this.setState({ visibleAlert: false })}
                    className="Alert"
                    overlayClassName="Overlay"
                >
                    <Container>
                        <Col className="my-auto" style={{ textAlign: "center", color: "#9b9daa", fontSize: 18, padding: 0 }}>{this.state.alert}</Col>
                        <Col className="alertClose" onClick={() => this.setState({ visibleAlert: !this.state.visibleAlert })}>Close</Col>
                    </Container>
                </Modal>
            </div>
        )
    }
}

let mapStateToProps = (state) => ({
    userInfo: JSON.parse(JSON.stringify(state.UserModule.get('userInfo'))),
});

let mapDispatchToProps = (dispatch) => ({
    userActions: bindActionCreators(UserActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdvertisementScreen);